module.exports = __webpack_public_path__ + "static/media/pcclsg4.9d47a5ef.png";